import Tile from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import TileGrid from 'ol/tilegrid/TileGrid';
import View from 'ol/View';
import {kijs, resolutions} from '../../config';

export const baseLayer = new Tile({
	title: "KIJS",
	source: new TileWMS({
	  url: 'https://wms.kartes.lv/' + kijs + '/wgs/15/',
	  params: {LAYERS: '0', VERSION: '1.1.1'},
	  tileGrid: new TileGrid({
		origin: [-20037508.342787001, -20037508.342787001],
		resolutions: resolutions
	  })
	})
});

export const view =  new View({
	center: [2684294, 7750223],
	zoom: 14,
	maxZoom: 18,
	minZoom: 6,
	projection: 'EPSG:3857',
	extent: [2039951,7220547, 3590705,8228293]
});


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/features/map/assets.js